import Heading from "@atlaskit/heading";
import type {ComponentProps} from "react";

export function AnankeHeading(props: ComponentProps<typeof Heading>) {
    return <Heading {...props} />;
}
